var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1667 3.66663H9.50008C5.33341 3.66663 3.66675 5.33329 3.66675 9.49996V14.5C3.66675 18.6666 5.33341 20.3333 9.50008 20.3333H14.5001C18.6667 20.3333 20.3334 18.6666 20.3334 14.5V12.8333",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3666 4.51651L8.7999 11.0832C8.5499 11.3332 8.2999 11.8248 8.2499 12.1832L7.89157 14.6915C7.75823 15.5998 8.3999 16.2332 9.30823 16.1082L11.8166 15.7498C12.1666 15.6998 12.6582 15.4498 12.9166 15.1998L19.4832 8.63318C20.6166 7.49984 21.1499 6.18318 19.4832 4.51651C17.8166 2.84984 16.4999 3.38318 15.3666 4.51651Z",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.425 5.45825C14.9834 7.44992 16.5417 9.00825 18.5417 9.57492",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.91ef78f7d43bb97865fa83d65954df27.svg";
export { ForwardRef as ReactComponent };